// extracted by mini-css-extract-plugin
export default {"h1":"Rating_h1__xns5G","span":"Rating_span__3dibO","h11":"Rating_h11__+kWUl"};